module.exports = __webpack_public_path__ + "img/cq.9e602cf3.webp";